
export const consentTabName = {
    EN: 'Consent',
    FR: 'J’accepte',
    PL: 'Zgoda',
    DE: 'Zustimmung'
}

export const detailsTabName = {
    EN: 'Details',
    FR: 'Détails',
    PL: 'Szczegóły',
    DE: 'Details'
}

export const aboutTabName = {
    EN: 'About cookies',
    FR: 'À propos des cookies',
    PL: 'O plikach cookie',
    DE: 'Über Cookies'
}

export const denyButton = {
    EN: 'Deny',
    FR: 'Je refuse',
    PL: 'Odrzuć',
    DE: 'Ablehnen'
}

export const setButton = {
    EN: 'Set preferences',
    FR: 'Paramètres des préférences',
    PL: 'Ustaw preferencje',
    DE: 'Präferenzen einstellen'
}

export const allowChosenButton = {
    EN: 'Allow chosen',
    FR: 'Autoriser la sélection',
    PL: 'Zaakceptuj wybrane',
    DE: 'Ausgewählte erlauben'
}

export const allowButton = {
    EN: 'Allow all',
    FR: 'Tout autoriser',
    PL: 'Zaakceptuj wszystkie',
    DE: 'Alle erlauben'
}

export const expireTitle = {
    EN: 'Expiry:',
    FR: 'Date d’expiration:',
    PL: 'Data wygaśnięcia:',
    DE: 'Ablauf:'
}

export const typeTitle = {
    EN: 'Type:',
    FR: 'Type:',
    PL: 'Typ:',
    DE: 'Typ:'
}

export const loadMoreTitle = {
    EN: 'LOAD MORE',
    FR: 'AFFICHER LA SUITE',
    PL: 'WCZYTAJ WIĘCEJ',
    DE: 'MEHR LADEN'
}

export const acceptCookiesFirst = {
    EN: 'Please accept',
    FR: 'Veuillez accepter la',
    PL: 'Proszę zaakceptować',
    DE: 'Bitte akzeptieren Sie die'
}

export const acceptCookiesSecond = {
    EN: 'COOKIES POLICY',
    FR: 'POLITIQUE EN MATIÈRE DE COOKIES',
    PL: 'POLITYKĘ PLIKÓW COOKIE',
    DE: 'COOKIES-RICHTLINIE'
}

export const acceptCookiesThird = {
    EN: 'to see the map',
    FR: 'pour afficher la carte',
    PL: 'aby zobaczyć mapę',
    DE: 'um die Karte zu sehen'
}